import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import TreeView from '@mui/lab/TreeView';
import { Typography } from '@mui/material';
import { useKeycloak } from '@react-keycloak/web';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import SidebarItem from './SidebarItem';

export default function Sidebar() {
  const { keycloak } = useKeycloak();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation(['sidebar', 'common']);
  const isAdmin =
    keycloak.hasResourceRole('ADMIN', process.env.REACT_APP_KEYCLOAK_CLIENT_ID) ||
    process.env.REACT_APP_ENV === 'dev';
  const isControladoria =
    keycloak.hasResourceRole('CONTROLADORIA', process.env.REACT_APP_KEYCLOAK_CLIENT_ID) ||
    process.env.REACT_APP_ENV === 'dev';
  const selectedTree = (endpoint: string) => {
    switch (endpoint) {
      case '/':
        return '1';
      case '/pmosharing':
        return '2';
      case '/teacherpayment':
        return '3';
      case '/events':
        return '4';
      case '/sharing':
        return '5';
      case '/accountingaccount':
        return '6';
      case '/branchresultcenter':
        return '8';
      case '/permissionByProduct':
        return '9';
      case '/debitnote':
        return '10';
      case '/nosharing':
        return '11';
      case '/classifyincentivized':
        return '12';
      default:
        return '1';
    }
  };
  return (
    <TreeView
      selected={selectedTree(location.pathname)}
      aria-label="gmail"
      defaultExpanded={['3']}
      defaultCollapseIcon={<ArrowDropDownIcon />}
      defaultExpandIcon={<ArrowRightIcon />}
      defaultEndIcon={<div style={{ width: 24 }} />}
      sx={{
        height: 264,
        flexGrow: 1,
        maxWidth: 250,
        paddingLeft: '2rem',
      }}
    >
      {isControladoria && (
        <>
          <Typography variant="h2" sx={{ marginY: '1rem', fontWeight: 'bold' }}>
            {t('important.data')}
          </Typography>
          <SidebarItem
            active={selectedTree(location.pathname) === '2'}
            nodeId="2"
            labelText={t('common:sharing.pmo')}
            labelInfo="3,566"
            color="#e3742f"
            bgColor="#fcefe3"
            badgeColor="warning"
            onClick={() => {
              navigate('pmosharing');
            }}
          />
          <SidebarItem
            active={selectedTree(location.pathname) === '3'}
            nodeId="3"
            labelText={t('common:teacher.payment')}
            labelInfo="3,566"
            color="#e3742f"
            bgColor="#fcefe3"
            badgeColor="warning"
            onClick={() => {
              navigate('teacherpayment');
            }}
          />
          <SidebarItem
            active={selectedTree(location.pathname) === '4'}
            nodeId="4"
            labelText={t('common:events')}
            labelInfo="3,566"
            color="#e3742f"
            bgColor="#fcefe3"
            badgeColor="warning"
            onClick={() => {
              navigate('events');
            }}
          />
        </>
      )}
      {isAdmin && (
        <>
          <Typography variant="h2" sx={{ marginY: '1rem', fontWeight: 'bold' }}>
            {t('common:sharing')}
          </Typography>
          <SidebarItem
            active={selectedTree(location.pathname) === '5'}
            nodeId="5"
            labelText={t('common:sharing')}
            color="#e3742f"
            bgColor="#fcefe3"
            onClick={() => {
              navigate('sharing');
            }}
          />
          <SidebarItem
            active={selectedTree(location.pathname) === '10'}
            nodeId="10"
            labelText={t('debit.note')}
            color="#e3742f"
            bgColor="#fcefe3"
            onClick={() => {
              navigate('debitnote');
            }}
          />
          <SidebarItem
            active={selectedTree(location.pathname) === '11'}
            nodeId="11"
            labelText={t('no.sharing')}
            color="#e3742f"
            bgColor="#fcefe3"
            onClick={() => {
              navigate('nosharing');
            }}
          />
        </>
      )}
      {isAdmin && (
        <>
          <Typography variant="h2" sx={{ marginY: '1rem', fontWeight: 'bold' }}>
            {t('settings')}
          </Typography>
          <SidebarItem
            active={selectedTree(location.pathname) === '12'}
            nodeId="12"
            labelText={t('common:classify.incentivized')}
            color="#e3742f"
            bgColor="#fcefe3"
            onClick={() => {
              navigate('classifyincentivized');
            }}
          />
          <SidebarItem
            active={selectedTree(location.pathname) === '6'}
            nodeId="6"
            labelText={t('common:accounting.accounts')}
            color="#e3742f"
            bgColor="#fcefe3"
            onClick={() => {
              navigate('accountingaccount');
            }}
          />

          <SidebarItem
            active={selectedTree(location.pathname) === '8'}
            nodeId="8"
            labelText={t('common:branch.result.center')}
            color="#e3742f"
            bgColor="#fcefe3"
            onClick={() => {
              navigate('branchresultcenter');
            }}
          />
          <SidebarItem
            active={selectedTree(location.pathname) === '9'}
            nodeId="9"
            labelText={t('common:permission.by.product')}
            color="#e3742f"
            bgColor="#fcefe3"
            onClick={() => {
              navigate('permissionByProduct');
            }}
          />
        </>
      )}
    </TreeView>
  );
}
